import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { Sidebar } from 'primereact/sidebar';

import SideMenu from './SubMenu';

import { fetchMenu } from '../../../services/redux/reducers/menu/menu';
import { checkPermissions } from '../../../utils';

import "./index.css"


const SideNav = (props) => {
    const { visible, setVisible } = props
    const [ menuList, setMenuList ] = useState([])

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const menuData = useSelector((state) => state.menu.menuData)
    const userDetails = useSelector(state => state.userDetails)
    const userDetilsLoadingStatus = useSelector((state) => state.userDetails.loading)
    
    useEffect(() => {
        dispatch(fetchMenu())
    },[])

    useEffect(() => {
        if(menuData.length && userDetails){
            getMenuData()
        }
    }, [menuData, userDetails])


    const getSubMenusSorted = (subMenuItems) => {
        const allParentIds = subMenuItems.map(eachSubMenuItem => eachSubMenuItem.parentId)
        const uniqueParentIds = [...new Set(allParentIds)]

        let sortedItems = []
        for (let eachParentId of uniqueParentIds){
            let items = []
            for (let eachSubMenu of subMenuItems){
                if (eachParentId === eachSubMenu.parentId){
                    items.push(eachSubMenu)
                }
            }
            items.sort(function(firstVal, secondVal){return firstVal.sequence - secondVal.sequence})
            sortedItems.push(...items)
        }
        
        return sortedItems
    }

    const getMenuData = () => {
        const allMenuList = menuData?.filter(eachMenuItem => eachMenuItem.sequence !== null)

        const permittedMenuList = allMenuList.filter(eachMenu => {
            if(eachMenu.permActionId){
                const permParams = {
                    reqPermActionIds: [eachMenu.permActionId],
                    activeCompanyRoleId: userDetails.activeCompanyRoleId,
                    userRoleId: userDetails.activeRoleId,
                    permExceptions: userDetails.permExceptions,
                    permGeo: userDetails.permGeo,
                    permActions: userDetails.permActions,
                    permRoles: userDetails.permRoles
                }
                const {isPermitted} = checkPermissions({...permParams, reqPermActionIds: [eachMenu.permActionId]})
                return isPermitted
            }
            return true
        })

        const subMenuItems = permittedMenuList.filter(eachItem => eachItem.isSubMenu)
        const sortedSubMenuItems = getSubMenusSorted(subMenuItems)
        
        const nonSubMenuItems = permittedMenuList.filter(eachItem => !eachItem.isSubMenu)
        nonSubMenuItems.sort((firstVal, secondVal) =>  firstVal.sequence - secondVal.sequence)
        const sortedMenuItems = [...nonSubMenuItems, ...sortedSubMenuItems]
        
        setMenuList(sortedMenuItems)
    }

    const navigateToLink = (link) => {
        navigate(link)
        setVisible(false)
    }

    const renderMenuItem = (menuObj) => {
        const childItems = menuList.filter(obj => obj.parentId === menuObj.menuId)

        const isParent = !menuObj.clientPath

        if(isParent && !childItems.length){
            return null
        }

        if(!menuObj.parentId){
            if(childItems.length > 0){
                return <SideMenu key={menuObj.menuId} menuObj={menuObj} childItems={childItems} navigateToLink={navigateToLink} />
            } else {
                return (
                    <li key={menuObj.menuId}>
                        <a className='' onClick={() => navigateToLink(menuObj.clientPath)}>
                            <div className="menu-icon"><i className={`menubar-icon ${menuObj?.menuIcon}`}></i></div>
                            { menuObj.name }
                        </a>
                    </li>

                )
            }
        }
        return null
    }

    return (
        <div className="card flex justify-content-center">
            <Sidebar visible={visible} onHide={() => setVisible(false)}>
                <nav className='layout-sidebar'>
                    { userDetilsLoadingStatus ? 
                        <div className="flex justify-content-center align-items-center h-full">
                            <ThreeDots height="50" width="50" radius="5"color="#00baac" ariaLabel="three-dots-loading" visible={true} /> 
                        </div> 
                        :
                        <ol className="layout-menu">
                            {
                                menuList.map(item => {
                                    return renderMenuItem(item)
                                })
                            }
                        </ol>
                    }
                </nav>
            </Sidebar>
        </div>
    )
}

export default SideNav
